{
  "ai.title": "AI-assistent",
  "ai.provider.available": "Beschikbaar",
  "ai.provider.unavailable": "Niet beschikbaar",
  "ai.provider.test_label": "BRES-testadapter",
  "ai.provider.test_badge": "Testadapter",
  "ai.provider.tm": "Vertaalgeheugen",
  "ai.provider.test_title": "Geen taalmodel: alleen testuitvoer",
  "ai.provider.test_body": "Lokaal draait de BRES-testadapter. Die vertaalt niet: een voorstel is de brontekst met een testlabel en de kosten zijn altijd nul. Zo test je budget, feitencontrole en review zonder echte AI.",
  "ai.provider.off_body": "Er is geen AI-provider ingesteld. Vertalen en beoordelen werkt gewoon met de hand.",
  "ai.provider.rule_proposals": "AI maakt alleen voorstellen. Een reviewer van de taal beslist.",
  "ai.provider.rule_facts": "Prijzen, oppervlaktes en andere feiten komen uit de woninggegevens, nooit uit AI.",
  "ai.budget.title": "Budget deze maand",
  "ai.budget.set": "Budget instellen",
  "ai.budget.day": "Dag {day} van {days}",
  "ai.budget.of_limit": "van {limit}",
  "ai.budget.no_limit": "geen limiet",
  "ai.budget.bar_label": "{spent} van {limit} verbruikt, dag {day} van {days}",
  "ai.budget.none": "Er is geen maandbudget ingesteld; AI-taken worden niet begrensd.",
  "ai.budget.hard_stop_on": "Harde stop: bij het budget starten geen nieuwe AI-taken. Bestaande vertalingen blijven werken.",
  "ai.budget.hard_stop_off": "Geen harde stop: AI-taken lopen door boven het budget.",
  "ai.budget.ahead": "Het verbruik loopt voor op de maand.",
  "ai.budget.no_rights": "Het budget stelt een beheerder in.",
  "ai.budget.by_task": "{count, plural, =0 {Per taak} one {Per taak, # taak deze maand} other {Per taak, # taken deze maand}}",
  "ai.budget.by_task_empty": "Deze maand nog geen AI-taken.",
  "ai.budget.task_count": "{count, plural, one {{n} taak} other {{n} taken}}",
  "ai.budget.dialog_title": "Maandbudget voor AI",
  "ai.budget.dialog_body": "Geldt voor alle AI-taken van deze organisatie, per kalendermaand.",
  "ai.budget.amount": "Bedrag per maand",
  "ai.budget.amount_hint": "Tussen 0 en 10.000.",
  "ai.budget.amount_invalid": "Kies een bedrag tussen 0 en 10.000.",
  "ai.budget.hard_stop": "Harde stop bij het budget",
  "ai.budget.save": "Budget opslaan",
  "ai.budget.saved": "Budget opgeslagen",
  "ai.budget.saved_body": "Nieuwe limiet: {limit} per maand.",
  "ai.jobs.title": "Recente taken",
  "ai.jobs.lead": "{count, plural, =0 {Nog geen taken.} one {De laatste taak, met herkomst en kosten.} other {De laatste # taken, met herkomst en kosten.}}",
  "ai.jobs.col_task": "Taak",
  "ai.jobs.col_outcome": "Uitkomst",
  "ai.jobs.col_by": "Gestart door",
  "ai.jobs.col_usage": "Kosten",
  "ai.jobs.col_created": "Gestart",
  "ai.jobs.by_system": "Systeem",
  "ai.jobs.tokens": "{in} in, {out} uit",
  "ai.jobs.tokens_title": "Invoertokens en uitvoertokens",
  "ai.jobs.error_detail": "Fout: {error}",
  "ai.jobs.test_output": "Testuitvoer (geen taalmodel)",
  "ai.jobs.origin": "Herkomst",
  "ai.jobs.any_task": "Alle taken",
  "ai.jobs.any_origin": "Alles",
  "ai.jobs.origin_provider": "AI-provider",
  "ai.jobs.origin_test": "Testuitvoer",
  "ai.jobs.clear": "Filters wissen",
  "ai.jobs.empty_title": "Nog geen AI-taken",
  "ai.jobs.empty_body": "Vraag een AI-voorstel aan bij Talen, Voorstellen.",
  "ai.jobs.empty_action": "Naar Voorstellen",
  "ai.jobs.empty_filtered_title": "Geen taken met deze filters",
  "ai.jobs.empty_filtered_body": "Kies een andere taak of herkomst.",
  "ai.task.localize": "Vertaalvoorstel",
  "ai.task.brief_from_text": "Woonwens uit tekst",
  "ai.task.reply_draft": "Antwoordconcept",
  "ai.task.quality_review": "Kwaliteitscontrole",
  "ai.status.queued": "In de wachtrij",
  "ai.status.running": "Bezig",
  "ai.status.succeeded": "Voorstel gemaakt",
  "ai.status.failed": "Mislukt",
  "ai.status.blocked_budget": "Gestopt door budget",
  "ai.status.blocked_checks": "Feitencontrole afgekeurd",
  "ai.status.accepted": "Overgenomen",
  "ai.status.rejected": "Afgewezen",
  "ai.outcome.draft": "Teruggestuurd",
  "ai.outcome.proposed": "Wacht op review",
  "ai.outcome.in_review": "Wacht op review",
  "ai.outcome.approved": "Goedgekeurd",
  "ai.outcome.rejected": "Afgewezen",
  "ai.outcome.stale": "Verouderd",
  "ai.outcome.superseded": "Vervangen",
  "ai.evals.title": "Evaluaties",
  "ai.evals.lead": "Vaste voorbeeldteksten per taal gaan door de provider. BRES controleert per taal feiten, schrift en inhoud.",
  "ai.evals.run": "Evaluatie draaien",
  "ai.evals.no_rights": "Evaluaties draait een beheerder.",
  "ai.evals.provider_off": "Zonder provider valt er niets te evalueren.",
  "ai.evals.done": "Evaluatie klaar: {passed} van {total} geslaagd",
  "ai.evals.done_test": "Testadapter: de uitslag zegt niets over vertaalkwaliteit.",
  "ai.evals.run_label": "Evaluatie",
  "ai.evals.run_option": "{when}, {passed} van {total}",
  "ai.evals.summary": "{passed} van {total} talen geslaagd",
  "ai.evals.cost": "Kosten {cost}",
  "ai.evals.test_note": "De testadapter vertaalt niet. Een geslaagde taal betekent hier alleen dat getallen en schrift kloppen in de onvertaalde bron; over vertaalkwaliteit zegt dit niets.",
  "ai.evals.quality_note": "Een geslaagde evaluatie toetst feiten en schrift, niet de taalkwaliteit. Native review blijft nodig.",
  "ai.evals.table_label": "Uitslag per taal",
  "ai.evals.expects_script": "verwacht {script} schrift",
  "ai.evals.col_locale": "Taal",
  "ai.evals.col_facts": "Feiten",
  "ai.evals.col_script": "Schrift",
  "ai.evals.col_content": "Inhoud",
  "ai.evals.col_result": "Uitslag",
  "ai.evals.facts_ok": "Kloppen",
  "ai.evals.facts_bad": "{count, plural, =0 {Afwijking} one {# afwijking} other {# afwijkingen}}",
  "ai.evals.script_ok": "Juist schrift",
  "ai.evals.script_bad": "Verkeerd schrift",
  "ai.evals.content_ok": "Gevuld",
  "ai.evals.content_bad": "Leeg",
  "ai.evals.passed": "Geslaagd",
  "ai.evals.failed": "Gezakt",
  "ai.evals.empty_title": "Nog geen evaluatie",
  "ai.evals.empty_body": "Draai een evaluatie om per taal te zien of de provider feiten en schrift goed houdt.",
  "ai.plan.title": "Je AI-functies",
  "ai.plan.lead": "Welke AI-functies in je abonnement zitten. BRES zet ze per klant of per site aan.",
  "ai.plan.not_in_plan": "Niet in je abonnement",
  "ai.plan.included": "In je abonnement",
  "ai.plan.whole_tenant": "Hele organisatie",
  "ai.plan.since": "sinds {date}",
  "ai.plan.request_button": "Interesse doorgeven",
  "ai.plan.request_short": "Interesse",
  "ai.plan.request_open": "Interesse doorgegeven",
  "ai.plan.request_title": "Interesse in {feature}",
  "ai.plan.request_site": "Voor de site {site}.",
  "ai.plan.request_message": "Bericht aan BRES",
  "ai.plan.request_send": "Interesse doorgeven",
  "ai.plan.requested_title": "Interesse doorgegeven",
  "ai.plan.requested_body": "BRES neemt contact met je op over prijs en mogelijkheden.",
  "ai.plan.ask_owner": "Vraag de eigenaar van je organisatie om interesse door te geven.",
  "ai.plan.paid_note": "Betaalde uitbreiding, per site aan of uit.",
  "ai.feature.translation": "AI-vertaalvoorstellen",
  "ai.feature.translation_pitch": "Vertaalvoorstellen voor woningteksten in de talen van je site, met feitencontrole en review door je team.",
  "ai.feature.translation_point1": "Feiten zoals prijs en oppervlakte blijven exact gelijk",
  "ai.feature.translation_point2": "Je woordenlijst wordt gevolgd",
  "ai.feature.translation_point3": "Niets gaat live zonder goedkeuring",
  "ai.feature.assist": "AI-hulp bij aanvragen",
  "ai.feature.assist_pitch": "Een woonwens uit vrije tekst halen en een antwoordconcept voor een aanvraag laten maken.",
  "ai.feature.assist_point1": "Zoekcriteria uit een e-mail of notitie",
  "ai.feature.assist_point2": "Antwoordconcept in de taal van de klant",
  "ai.feature.assist_point3": "Jij leest na en verstuurt zelf",
  "ai.feature.blog": "AI-blog",
  "ai.feature.blog_pitch": "Artikelen per taal over je regio en het koopproces, met feiten uit je eigen bronnenlijst en advies dat past bij het land van de lezer.",
  "ai.feature.blog_point1": "Concept per taal, jij herschrijft en keurt goed",
  "ai.feature.blog_point2": "SEO-controles, interne links naar gebieden en woningen",
  "ai.feature.blog_point3": "Publiceren via je gewone website-publicatie",
  "ai.feature.chat": "AI-chatbot",
  "ai.feature.chat_pitch": "Een assistent op je website die vragen beantwoordt met je echte aanbod en je eigen kennis, en bezoekers met hun toestemming doorzet naar een aanvraag.",
  "ai.feature.chat_point1": "Antwoorden met links naar echte woningen",
  "ai.feature.chat_point2": "Aanvraag in BRES alleen met toestemming",
  "ai.feature.chat_point3": "Kostenplafond per dag en per maand",
  "ai.task.blog_draft": "Blogconcept",
  "ai.task.chat_reply": "Chatantwoord",
  "ai.budget.cap_note": "BRES-plafond: {cap} per maand"
}
